// src/pages/PlansPage.jsx
import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom"; // v5
import axios from "axios";
import AuthContext from "../../Context/AuthContext";
import authHeader from "../../utils/authHeader";

const API_BASE = "https://opt-api.vercel.app";

export default function PlansPage() {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { userData } = useContext(AuthContext);
  const user = userData?.user?.user;
  const name = user?.brandId || user?.username || "";
  const isViewer = user?.role === "viewer";

  useEffect(() => {
    // name yoksa istek atma
    if (!name) {
      setItems([]);
      setError("");
      return;
    }

    let alive = true;

    (async () => {
      try {
        setLoading(true);
        setError("");
        const { data } = await axios.post(`${API_BASE}/Plans2`, { name }, authHeader());
        if (!alive) return;

        const normalized = (data || []).map((x) => ({
          id: x._id || x.id,
          name: x.name || x.title || "Adsız Kampanya",
        }));
        setItems(normalized);
      } catch (e) {
        if (!alive) return;
        setError(e?.message || "Kampanyalar alınamadı");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [name]); // 👈 name değişirse tekrar çalışır


  const openDetail = (id) => history.push(`/CampaignDetail/${id}`);

  return (
    <div className="container mx-auto max-w-6xl px-4 py-8">
      {/* Header */}
      <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-800">
            {name}
          </h1>
          <p className="text-slate-500 mt-1">
            Kampanyalar
            {/* {items?.length ? (
              <>
                {" "}
                • <span className="font-medium text-slate-700">{items.length}</span> adet
              </>
            ) : null} */}
          </p>
        </div>

        {/* <button
          onClick={() => history.push("/NewPlan")}
          className="inline-flex items-center gap-2 h-11 px-4 rounded-lg bg-blue-600 text-white text-sm font-medium shadow-sm hover:bg-blue-700 active:translate-y-px transition"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" className="opacity-90">
            <path
              fill="currentColor"
              d="M12 5v14m7-7H5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          Yeni Plan
        </button> */}
      </div>

      {/* Loading */}
      {loading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="p-4 rounded-xl border border-slate-200 bg-white shadow-sm animate-pulse"
            >
              <div className="h-5 w-2/3 bg-slate-200 rounded mb-3" />
              <div className="h-4 w-1/2 bg-slate-200 rounded" />
              <div className="mt-4 h-8 w-full bg-slate-200 rounded" />
            </div>
          ))}
        </div>
      )}

      {/* Error */}
      {!loading && error && (
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-rose-700 mb-6">
          <div className="flex items-start gap-3">
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 9v4m0 4h.01M12 3L1 21h22L12 3Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>
              <div className="font-medium">Bir şeyler ters gitti</div>
              <div className="text-sm opacity-90">{error}</div>
            </div>
          </div>
        </div>
      )}

      {/* Empty state */}
      {!loading && !error && items.length === 0 && (
        <div className="rounded-2xl border border-dashed border-slate-300 p-10 text-center bg-white">
          <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-slate-100 mb-3">
            <svg width="22" height="22" viewBox="0 0 24 24" className="text-slate-500">
              <path
                fill="currentColor"
                d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                opacity=".15"
              />
              <path
                fill="currentColor"
                d="M5 5h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm7 6H7v2h5v-2Zm5 4H7v2h10v-2Z"
              />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-slate-800">Henüz kampanya yok</h2>
          <p className="text-slate-500 mt-1">
            {isViewer ? "Henüz görüntülenecek kampanya yok." : "İlk planınızı oluşturarak listeyi başlatın."}
          </p>
          {!isViewer && (
            <button
              onClick={() => history.push("/NewPlan")}
              className="mt-4 inline-flex items-center gap-2 h-10 px-4 rounded-lg border border-slate-300 bg-white text-slate-700 text-sm hover:bg-slate-50"
            >
              Plan oluştur
            </button>
          )}
        </div>
      )}

      {/* List */}
      {!loading && !error && items.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c) => (
            <button
              key={c.id}
              onClick={() => openDetail(c.id)}
              className="group text-left rounded-xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md hover:border-slate-300 transition relative"
              aria-label={`${c.name} kampanya detayına git`}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  {/* <div className="text-sm uppercase tracking-wide text-slate-400">
                    Kampanya
                  </div> */}
                  <div className="mt-1 text-base font-medium text-slate-800 line-clamp-2">
                    {c.name}
                  </div>
                </div>
                <div className="shrink-0 h-8 w-8 rounded-full bg-slate-100 grid place-items-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    className="text-slate-500 group-hover:translate-x-0.5 transition-transform"
                  >
                    <path
                      fill="currentColor"
                      d="M9 18l6-6-6-6"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* <div className="mt-4 flex items-center gap-2 text-xs text-slate-500"> */}
                {/* <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-1">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  Aktif
                </span> */}
                {/* <span className="opacity-70">•</span> */}
                {/* <span className="truncate">Sonuçlara gitmek için tıklayın</span> */}
              {/* </div> */}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
